import { render, staticRenderFns } from "./CambioNuevo.vue?vue&type=template&id=4010dc5f"
import script from "./CambioNuevo.vue?vue&type=script&lang=js"
export * from "./CambioNuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports